export const API_HOST = "https://powerful-ocean-50126.herokuapp.com";
export const API_GET_DATA = `${API_HOST}/posts/1`; // to-do list
export const API_GET_DATA_2 = `${API_HOST}/posts/2`; // finished task
